export default __webpack_public_path__ + "static/media/Snd_LowerHSwim.5319fdec.mp3";